<script setup lang="ts">
  import { MpIcon, MpText } from '@borg/ui';

  const job = jobRepository.use();
</script>

<template>
  <div
    v-if="job && !job.isActive"
    class="notification"
  >
    <MpIcon icon="close" />
    <MpText
      semibold
      no-margin
    >
      {{ $t('JOB_CARD.INACTIVE_LABEL') }}
    </MpText>
  </div>
</template>

<style scoped lang="scss">
  .notification {
    display: flex;
    align-items: center;
    gap: var(--mp-space-30);
    padding: var(--mp-space-50) 0;
    background-color: var(--mp-color-surface-30);
    border: 1px solid var(--mp-color-grey-200);
    padding: var(--mp-space-60);
    border-radius: var(--mp-radius-40);
    color: var(--mp-color-status-error);
  }
</style>
